import { classes } from "../Data/Layouts";
import { stripAppBasename } from "./appBase";

export const DEFAULT_LAYOUT_SLUG = "Dubai";

export const LAYOUT_SLUGS = classes.map((entry) => Object.keys(entry)[0]);

export function getLayoutEntry(slug) {
  return classes.find((entry) => Object.keys(entry)[0] === slug);
}

export function getDefaultLayoutEntry() {
  return getLayoutEntry(DEFAULT_LAYOUT_SLUG) || classes[0];
}

function applyLayoutSlug(slug) {
  const entry = getLayoutEntry(slug) || getDefaultLayoutEntry();
  const resolvedSlug = Object.keys(entry)[0];
  const layoutClass = Object.values(entry)[0];
  localStorage.setItem("layout", resolvedSlug);
  localStorage.setItem("sidebar_layout", layoutClass);
  return resolvedSlug;
}

const LAYOUT_DEFAULT_MIGRATION_KEY = "credora_default_layout_dubai_v1";

/** Persist Credora's default theme layout (Dubai) when none is stored yet. */
export function ensureDefaultLayoutStorage() {
  const stored = localStorage.getItem("layout");
  if (!stored || !LAYOUT_SLUGS.includes(stored)) {
    applyLayoutSlug(DEFAULT_LAYOUT_SLUG);
    return;
  }
  // One-time migration: Barcelona was never intended as the Credora default.
  if (stored === "Barcelona" && !localStorage.getItem(LAYOUT_DEFAULT_MIGRATION_KEY)) {
    applyLayoutSlug(DEFAULT_LAYOUT_SLUG);
    localStorage.setItem(LAYOUT_DEFAULT_MIGRATION_KEY, "1");
  }
}

/**
 * Active layout slug: URL segment (if valid) → stored layout → Dubai.
 */
export function getActiveLayoutSlug(pathname = window.location.pathname) {
  const parts = stripAppBasename(pathname).split("/").filter(Boolean);
  const last = parts[parts.length - 1];
  if (LAYOUT_SLUGS.includes(last)) {
    return last;
  }
  const stored = localStorage.getItem("layout");
  if (stored && LAYOUT_SLUGS.includes(stored)) {
    return stored;
  }
  return DEFAULT_LAYOUT_SLUG;
}
